import script from "./SharedDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SharedDialog.vue?vue&type=style&index=0&id=7d0e051b&lang=postcss"

const __exports__ = script;

export default __exports__